import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ValidatorFn} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {PopinService} from '../services/popin.service';
import {Popin} from '../models/popin.model';
import {takeUntil} from 'rxjs/operators';
import {timer} from 'rxjs';
import {ApiCoefficyService} from '../services/api-coefficy.service';
import {Data} from '../providers/data.provider';
import {IpService} from '../services/ip.service';
import {DatasaveService} from '../services/datasave.service';

@Component({
  selector: 'app-popin-one',
  templateUrl: './popin-one.component.html',
  styleUrls: ['./popin-one.component.scss']
})
export class PopinOneComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private popinService: PopinService,
              private ipService: IpService,
              private coefficy: ApiCoefficyService,
              private datasaveService: DatasaveService,
              private data: Data,
              private route: ActivatedRoute) {}

  public static MAILTYPE_SIMPLEVISITCLIENT = '5ebab5c1cdc85c1c941f6124';
  public static MAILTYPE_SIMPLEVISITPROSPECT = '5ebab5c1cdc85c1c941f6125';
  public static MAILTYPE_INTERETCONTENUPROSPECT = '5ebab5c1cdc85c1c941f6126';
  public static MAILTYPE_SUPPORTTECHNIQUE = '5ebab5c1cdc85c1c941f6127';
  public static MAILTYPE_CONTACTCOMMERCIAL = '5ebab5c1cdc85c1c941f6128';
  public static MAILTYPE_CONTACTADMINISTRATIF = '5ebab5c1cdc85c1c941f6129';

  public static VISITTYPE_SIMPLEVISITE = '5ebab65bcdc85c1c941f612a';
  public static VISITTYPE_SUPPORTTECHNIQUE = '5ebab65bcdc85c1c941f612b';
  public static VISITTYPE_CONTACTCOMMERCIAL = '5ebab65bcdc85c1c941f612c';
  public static VISITTYPE_CONTACTADMINISTRATIF = '5ebab65bcdc85c1c941f612d';
  public static VISITTYPE_INTERETCONTENU = '5ebab65bcdc85c1c941f612e';
  public static VISITTYPE_NOUVELLESOCIETE = '5ef0c2c720298b60105bfc07';

  public static productCustomer: any = null;
  public static isCustomer = false;
  public static customer: any;
  public static popinId: string;
  public static host: string = null;
  public static uri: string = null;
  public static visitRandomId: string = null;
  public static popinOpened = false;
  public customerIdentifier: string;
  public isLoading: boolean;
  public AutoComplete$ = [];
  public timer: any;
  public error3s = false;
  public postalCode = /((0[1-9])|([1-8][0-9])|(9[0-8])|(2A)|(2B))[0-9]{3}/;
  public noresult = false;
  public titleColor: string;
  public position = 0;
  public borderRadius = true;
  public companyRequired = true;
  public loading = false;
  public popinForm: FormGroup;
  public popin: Popin;
  public webpageList: any = [];
  public webpageTest = false;
  public session: any;
  public geoloc: string;
  public title: string;
  public newCompanyLinkIsActive: string;
  public newCompanyLinkTitle: string;
  public newCompanyLinkUrl: string;

  private static loadFont(font) {
    const formFont = document.createElement('link');
    formFont.setAttribute('rel', 'stylesheet');
    formFont.setAttribute('href', `https://fonts.googleapis.com/css?family=${font.replace(' ', '+')}&display=swap`);
    document.head.appendChild(formFont);
  }

  ngOnInit(): void {
    this.loading = true;
    PopinOneComponent.visitRandomId = (this.route.snapshot.params['visitRandomId']) ? this.route.snapshot.params['visitRandomId'] : null;
    PopinOneComponent.uri = this.route.snapshot.params['url'];
    this.popinForm = this.formBuilder.group({
      autocompleteField: [null]
    });
    this.ipService.getGeoloc()
      .then(geoloc => {
        this.geoloc = geoloc as string;
        this.getParentHost();
      })
      .catch(error => console.log(error));
  }

  loadPopin() {
    this.loading = true;
    this.popinService.getPopin(PopinOneComponent.host)
      .then((popin) => {
        if (!popin || !popin['account'].isActive) {
          this.sendEventToParent('noloading');
          return;
        }
        this.loading = false;
        PopinOneComponent.popinId = popin['_id'];
        this.webpageList.push(popin['webpage1']);
        this.webpageList.push(popin['webpage2']);
        this.webpageList.push(popin['webpage3']);
        this.webpageList.push(popin['webpage4']);
        this.webpageList.push(popin['webpage5']);

        if (popin['locatedInFrance'] && this.geoloc !== 'FR') {
          console.log('Popin non activé dans ce pays !');
          this.sendEventToParent('noloading');
          return;
        }

        switch (popin['webpageIsActive']) {
          case 'false':
            this.webpageTest = true;
            break;
          case 'include':
            this.webpageTest = false;
            for (const webpage of this.webpageList) {
              if (webpage === PopinOneComponent.uri) {
                this.webpageTest = true;
              }
            }
            break;
          case 'exclude':
            this.webpageTest = true;
            for (const webpage of this.webpageList) {
              if (webpage === PopinOneComponent.uri) {
                this.webpageTest = false;
              }
            }
            break;
        }

        if (this.webpageTest) {
          if (popin && popin['isActive']) {
            this.title = (popin['title'] ? popin['title'] : 'Recherchez votre entreprise et personnalisez votre navigation !');
            this.position = popin['position'];
            this.borderRadius = popin['borderRadius'];
            this.companyRequired = popin['companyRequired'];
            this.newCompanyLinkIsActive = popin['newCompanyLinkIsActive'];
            this.newCompanyLinkTitle = popin['newCompanyLinkTitle'];
            this.newCompanyLinkUrl = popin['newCompanyLinkUrl'];
            this.titleColor = popin['titleColor'];
            if (popin['closeButton']) {
              this.sendEventToParent('closeButton');
            }
            this.loadCss(popin);
            PopinOneComponent.loadFont(popin['font']);

            this.popinService.getAccountInfos(popin['account']._id)
              .then(accountInfos => {
                this.data.storage = {
                  companyAccount: accountInfos,
                  huntingManager: popin['huntingManager'],
                  visitorLinks: {
                    visitorTitle1: popin['visitorTitle1'],
                    visitorLink1: popin['visitorLink1'],
                    visitorTitle2: popin['visitorTitle2'],
                    visitorLink2: popin['visitorLink2'],
                    visitorTitle3: popin['visitorTitle3'],
                    visitorLink3: popin['visitorLink3']
                  },
                  website: PopinOneComponent.host
                };
                if (!PopinOneComponent.popinOpened) {
                  PopinOneComponent.popinOpened = true;
                  const popOpened = {
                    popin: PopinOneComponent.popinId,
                    visitRandomId: PopinOneComponent.visitRandomId
                  };
                  this.datasaveService.saveOpenedPopin(popOpened);
                }
                this.sendEventToParent('loading');
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log('Popin introuvable, vérifier la configuration !');
            this.sendEventToParent('noloading');
          }
        } else {
          console.log('Popin non activé sur cette page !');
          this.sendEventToParent('noloading');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onSubmit() {
    this.popinService.getCoefficyInformations(this.customerIdentifier)
      .then(result => {
        PopinOneComponent.customer = result[0];
        this.popinService.isCustomer(PopinOneComponent.customer.SIREN, PopinOneComponent.popinId)
          .then(productClients => {
            this.session = {
              type: 'session',
              data: PopinOneComponent.customer
            };
            this.sendEventToParent(this.session);
            if (PopinOneComponent.visitRandomId !== 'false') {
              this.coefficy.visitIdentification(PopinOneComponent.visitRandomId, PopinOneComponent.customer.SIREN);
            }
            if (Object.keys(productClients).length > 0) {
              this.popinService.getProductById(productClients)
                .then(products => {
                  PopinOneComponent.productCustomer = products;
                  PopinOneComponent.isCustomer = true;
                })
                .catch(error => console.log(error));
              this.router.navigate(['/customer', { visitRandomId: PopinOneComponent.visitRandomId }]);
            } else {
              this.router.navigate(['/visitor', { visitRandomId: PopinOneComponent.visitRandomId }]);
            }
          })
          .catch(error => console.log(error));
      })
      .catch(error => console.log(error));
  }

  loadCss(popin) {
    document.documentElement.style.setProperty('--backgroundColor', popin.backgroundColor);
    document.documentElement.style.setProperty('--titleColor', popin.titleColor);
    document.documentElement.style.setProperty('--fieldColor', popin.fieldColor);
    document.documentElement.style.setProperty('--textColor', popin.textColor);
    document.documentElement.style.setProperty('--buttonColor', popin.buttonColor);
    document.documentElement.style.setProperty('--textButtonColor', popin.textButtonColor);
    document.documentElement.style.setProperty('--borderColor', popin.borderColor);
    document.documentElement.style.setProperty('--linkColor', popin.linkColor);
    document.documentElement.style.setProperty('--font', popin.font);
  }

  getParentHost() {
    PopinOneComponent.host = document.referrer.split('/')[2];
    // PopinOneComponent.uri = document.referrer ? document.referrer : document.documentURI;
    this.loadPopin();
  }

  sendEventToParent(event) {
    window.parent.postMessage(event, PopinOneComponent.uri);
  }

  public change($event) {
    if ($event !== '') {
      if (typeof $event === 'object') {
        this.customerIdentifier = $event.siren;
        this.onSubmit();
      } else if ($event.trim().length === 5 && this.postalCode.test($event.trim())) {
        this.AutoComplete$ = [];
      } else {
        if (this.timer == null) {
          this.autocomplete($event);
        } else {
          clearTimeout(this.timer);
          this.autocomplete($event);
        }
      }
    }
  }

  public autocomplete(searchTerm) {
    this.timer = setTimeout((newValidator: ValidatorFn | ValidatorFn[] | null) => {
      this.AutoComplete$ = [];
      this.error3s = false;
      this.isLoading = true;
      const request = this.coefficy.getFormData(searchTerm.replace(' ', '%20'));
      request.subscribe((res) => {
        if (typeof res === 'object') {
          const jsonObj = JSON.parse(JSON.stringify(res));
          if (jsonObj.length > 0) {
            this.noresult = false;
            for (const org of jsonObj) {
              let website = org.website.split("/")[2];
              // Gestion du cas "https://null/"
              if (website != 'null') {
                org.website = website;
              }
              this.AutoComplete$.push(org);
            }
          } else {
            this.noresult = true;
          }
        }
      }, (err) => {
        console.log(err);
        this.isLoading = true;
        this.error3s = true;
      }, () => {
        this.isLoading = false;
        this.error3s = false;
      });
      // Test du CP et alerte si +3s
      if (!this.postalCode.test(searchTerm)) {
        timer(3000).pipe(takeUntil(request)).subscribe(next => {
          this.error3s = true;
        }, err => {
          console.log(err);
        });
      }
    }, 750);
  }

  public displayFn(org): string {
    return org ? org.companyName : org;
  }

  newCompanyRedirect() {
    const redirect = {
      type: 'redirect',
      url: this.newCompanyLinkUrl
    };
    const popinvisit = {
      popin: PopinOneComponent.popinId,
      companyIdentifier: '0',
      isCustomer: false,
      visitType: PopinOneComponent.VISITTYPE_NOUVELLESOCIETE,
      product: null,
      visitRandomId: PopinOneComponent.visitRandomId,
      visitorContent: null
    };
    this.datasaveService.saveVisitData(popinvisit);
    window.parent.postMessage(redirect, PopinOneComponent.uri);
  }

}
